import { getCurrentBalance } from "../../js/api/balance.js";
import { createUser } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let role = localStorage.getItem("role");

let CreateUsers = {
  render: async () => {




    let view = /*html*/ `
            <div class="createUsersHeader">
                 <a class="backBtn">
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                 </a>
                 <span>${_t('Krijo Perdorues te ri')}</span>
           </div>
           <div class="createUsersWrapper m-t-6">
                <div class="createUsersHolder m-t-6">
                  <div class="form-group">
                    <input type="text" placeholder="${_t('Perdoruesi')}" id="txtUsername">
                    <input type="password" placeholder="${_t('Fjalekalimi')}" id="txtPassword">
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="${_t('Emri')}" id="txtFirstName">
                    <input type="text" placeholder="${_t('Mbiemri')}" value="" id="txtSurname">
                  </div>
                    ${role == 'SupermanagerTest' ? `
                      <input type="number" placeholder="% - 1" value="4" id="txtSinglePercentage">
                      <input type="number" placeholder="% - 2" value="8" id="txtDoublePercentage">
                      <input type="number" placeholder="% - 3" value="8" id="txtTriplePercentage">`: ""
                    }
                    <div class="form-group">
                      <select name="" id="selectCurrency">
                      </select>
                    </div>

                    <a class="updateCreateUserBtn" id="createUserBtn" style="margin-top: 0; margin-bottom: 15px">${_t('Regjistrohu')}</a>
                </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {

    var currentBalanceResult = await getCurrentBalance();
    var allText = '';

    if (role == "Supermanager" || role == "Manager" || role == "Administrator" || role == "Superadmin" || role == "CompanyAdmin") {
      $("#selectCurrency").append(`<option value="0"> 
        ${_t('Të gjitha')}
      </option>`);
    }

    if (currentBalanceResult.total_coins.includes('|')) {
      var allCoins = currentBalanceResult.total_coins.split('|');

      allCoins.forEach((element) => {
        const currencyId = element.split(';')[0].split('.')[0];
        const currency = element.split(';')[0].split('.')[1];

        $("#selectCurrency").append(`<option value="${currencyId}"> 
         ${currency}
        </option>`);
      });
    } else {
      if (currentBalanceResult.currency) {
        $("#selectCurrency").append(`<option value="${currentBalanceResult.currency_id}"> 
        ${Utils.currencyCode(currentBalanceResult.currency)}
      </option>`);
      } else {
        const currency = currentBalanceResult.total_coins.split(';')[0].split('.')[1];
        const value = currentBalanceResult.total_coins.split(';')[1];
        const id = currentBalanceResult.total_coins.split(';')[0].split('.')[0];
        $("#selectCurrency").append(`<option value="${id}"> 
        ${currency}
      </option>`);
      }

    }




    //name,surname,username,email,password,currency


    const submitBtn = document.getElementById('createUserBtn');
    if (submitBtn) {
      submitBtn.addEventListener('click', async () => {
        const Username = document.getElementById("txtUsername").value;
        const Password = document.getElementById("txtPassword").value;
        const FirstName = document.getElementById("txtFirstName").value;
        const Surname = document.getElementById("txtSurname").value;
        const Currency = document.getElementById("selectCurrency").value;
        const singlePercentage = document.getElementById("txtSinglePercentage") ? document.getElementById("txtSinglePercentage").value : "0";
        const doublePercentage = document.getElementById("txtDoublePercentage") ? document.getElementById("txtDoublePercentage").value : "0";
        const triplePercentage = document.getElementById("txtTriplePercentage") ? document.getElementById("txtTriplePercentage").value : "0";

        // Check if password has 8 characters, and includes at least one number and one letter
        if (Password.length < 8 || !/\d/.test(Password) || !/[a-zA-Z]/.test(Password)) {
          alert(_t("Password must be at least 8 characters long and include at least one number and one letter!"));
          return;
        }

        const result = await createUser({
          name: FirstName,
          surname: Surname,
          currency: Currency,
          password: Password,
          username: Username,
          single_percentage: singlePercentage,
          double_percentage: doublePercentage,
          triple_percentage: triplePercentage,
          partner_type: singlePercentage != "0" || doublePercentage != "0" || triplePercentage != "0" ? "turnover_percentage" : "no_percentage"
        });

        if (result.success) {
          alert(result.error);
          if (result.success == "OK")
            window.location.href = "#/users";
        }
      });
    }
  },
  hideFooterCasino: true
};

export default CreateUsers;
